import Vue from'vue';export default{pixelHeight:462,pixelWidth:74,get ratio(){return{width:this.pixelHeight/this.heights.xl,height:this.pixelWidth/this.widths.xs}},step:6.4,initial_step:3.5,heights:{l:200,xl:250},widths:{xs:40,s:60,m:75.5,l:90}};


//////////////////
// WEBPACK FOOTER
// ./app/components/data/k1_wall.js
// module id = 210
// module chunks = 0